/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import { useQuery } from '@tanstack/react-query';
import { getPermissions } from '../services/permissionsService';

export async function getPermissionsService() {
  try {
    const { data } = await getPermissions();
    return data;
  } catch {
    return null;
  }
}

export function useRolePermissions() {
  return useQuery({
    queryKey: ['rolePermissions'],
    queryFn: () => getPermissionsService(),
    staleTime: 1000 * 60 * 10, // 10 minutes,
    placeholderData: {
      configuration: {
        'sms-templates': {
          manage: true,
          see: true,
        },
        'email-templates': {
          manage: true,
          see: true,
        },
        'email-provider': {
          manage: true,
          see: true,
        },
        'rules-engine': {
          manage: true,
          see: true,
        },
        'rules-trigger': {
          manage: true,
          see: true,
        },
        'sms-provider': {
          manage: true,
          see: true,
        },
        customization: {
          manage: true,
          see: true,
        },
      },
      'create-report': {
        manage: true,
        see: true,
      },
      dashboard: {
        manage: true,
        see: true,
      },
      management: {
        'asset-library': {
          manage: true,
          see: true,
        },
        'asset-wizard': {
          manage: true,
          see: true,
        },
        assets: {
          manage: true,
          see: true,
        },
        displays: {
          manage: true,
          see: true,
        },
        'part-library': {
          manage: true,
          see: true,
        },
        parts: {
          manage: true,
          see: true,
        },
        roles: {
          manage: true,
          see: true,
        },
        'sensor-library': {
          manage: true,
          see: true,
        },
        sensors: {
          manage: true,
          see: true,
        },
        'service-tickets': {
          manage: true,
          see: true,
        },
        users: {
          manage: true,
          see: true,
        },
      },
      map: {
        manage: true,
        see: true,
      },
    },
  });
}
